const nextFrame = (run) =>
  typeof window !== "undefined" && typeof window.requestAnimationFrame === "function"
    ? window.requestAnimationFrame(() => window.requestAnimationFrame(run))
    : setTimeout(run, 0);

export const keepInPlace = (element, change) => {
  if (!element || typeof element.getBoundingClientRect !== "function") {
    change();
    return;
  }
  const before = element.getBoundingClientRect().top;
  change();
  nextFrame(() => {
    if (!element.isConnected) return;
    const moved = element.getBoundingClientRect().top - before;
    if (Math.abs(moved) >= 1 && typeof window.scrollBy === "function") window.scrollBy(0, moved);
  });
};
